import React from 'react';
import { Text, Colors } from 'library';
import { Grid, useMediaQuery } from '@mui/material';
import Teapot from 'assets/images/eldercare/teapot.png';
import theme from 'theme';

export default function EldercareInfoSection({ ButtonGroup }: { ButtonGroup: React.FC }) {
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <Grid
            xs={12}
            style={{ gap: 30, backgroundColor: Colors.lightTurq, padding: smDown ? 20 : 50 }}
            justifyContent="center"
            container
            item
        >
            <Grid item xs={12} md={6} style={{ padding: smDown ? 30 : 40, paddingRight: smDown ? 30 : 100 }}>
                <Text variant="display">Let's make the senior care industry better, together.</Text>
                <Text>
                    Tandem specializes in connecting senior care facilities with qualified and job-ready staff,
                    eliminating other costly staffing solutions and streamlining the process of finding and hiring
                    staff.
                </Text>
                <ButtonGroup />
            </Grid>
            <Grid xs={10} lg={5} container item justifyContent="center">
                <img
                    src={Teapot}
                    alt="eldercare-teapot"
                    height={smDown ? 250 : 350}
                    style={{ marginTop: smDown ? 40 : undefined }}
                />
            </Grid>
        </Grid>
    );
}
